import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetPendingActionsCount } from "api/generated/pending-actions/pending-actions";

export function usePendingActionsCountQuery(enabled: boolean) {
    return useGetPendingActionsCount({
        query: {
            enabled,
            select: ({ data }) => data.controls + data.tests,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
